import { COLORS } from "../../../constants";

export const marketingSalesConstants = {
  MARKETING_SALES_SPINNER: "MARKETING_SALES_SPINNER",
  GET_MARKETING_SALES: "GET_MARKETING_SALES",
  GET_SALES_REPORT: "GET_SALES_REPORT",
  GET_TOTAL_EMAIL_AND_SMS_DELIVERED_COUNT:
    "GET_TOTAL_EMAIL_AND_SMS_DELIVERED_COUNT",
};

export const marketingSalesColumnHeaderConstants = {
  INDIVIDUAL_CAMPAIGNS: "Individual Campaigns",
  TITLE: "Title",
  STORE: "Store",
  EMAIL_STATS: "Email Stats",
  SENT: "Sent",
  DELIVERED: "Delivered",
  OPENED: "Opened",
  CLICKED: "Clicked",
  TEXTS_MSGS_STATS: "Text Message Stats",
  ORDERS: "Orders",
  REVENUE: "Revenue",
};

export const marketingSalesChartLabelConstants = {
  TYPE: "Type",
  SALES: "Sales",
  ORDERS: "Orders",
  MARKETING_GENERATED_SALES: "Marketing Generated Sales",
  NON_MARKETING_SALES: "Non-Marketing Sales",
  MARKETING_ATTRIBUTED_ORDERS: "Marketing Attributed Orders",
  NON_MARKETING_ORDERS: "Non-Marketing Orders",
  CAMPAIGN_CONVERSION_RATE: "Campaign Conversion Rate",
  CAMPAIGN_CONVERSION_RATE_DESCRIPTION:
    "Total Marketing Orders / Total Email & SMS",
  TOTAL: "Total:",
};

export const MARKETING_SALES_SORTING = Object.freeze({ id: "campaignTitle", desc: true });
export const MARKETING_SALES_LABELS = Object.freeze({
  TABLE_TITLE: "Campaign Metrics: ",
});
export const MARKETING_SALES_CHART = Object.freeze({
  TYPE: "PieChart",
  WIDTH: "100%",
  HEIGHT: "20em",
});
export const MARKETING_SALES_CHART_OPTIONS = {
  title: "",
  pieHole: 0.4,
  is3D: false,
  colors: [COLORS.DARK_GREEN, COLORS.LIGHT_GREEN],
  backgroundColor: COLORS.GREY,
  pieSliceText: "none",
  legend: "none",
  sliceVisibilityThreshold: -1,
};

// Keep the empty chart visible while report totals are zero.
export const MARKETING_SALES_EMPTY_CHART = [
  [marketingSalesChartLabelConstants.TYPE, marketingSalesChartLabelConstants.SALES],
  [marketingSalesChartLabelConstants.NON_MARKETING_SALES, 1],
];
